import { sha256 } from 'js-sha256';

const storage = localStorage;

export const hashString = (str) => sha256(str);

export const STORAGE_KEYS = {
	EQUIPMENTS: 'equipments',
	IMAGES: 'images',
	BACKGROUND: 'background',
	BANNER: 'banner',
	LOGO1: 'logo1',
	LOGO2: 'logo2',
};

export const getStorageItem = (key) => {
	try {
		const item = storage.getItem(key);
		return item ? JSON.parse(item) : null;
	} catch (error) {
		console.error(`Error reading from storage (${key}):`, error);
		return null;
	}
};

export const setStorageItem = (key, value) => {
	try {
		storage.setItem(key, JSON.stringify(value));
	} catch (error) {
		console.error(`Error writing to storage (${key}):`, error);
	}
};

export const removeStorageItem = (key) => {
	try {
		storage.removeItem(key);
	} catch (error) {
		console.error(`Error removing from storage (${key}):`, error);
	}
};

export const clearStorage = () => {
	try {
		storage.clear();
	} catch (error) {
		console.error('Error clearing storage:', error);
	}
};

const readValidItems = (key) => {
	const items = getStorageItem(key) || [];
	const now = new Date().getTime();
	const validItems = items.filter((item) => now <= item.expiry);

	if (validItems.length !== items.length) {
		setStorageItem(key, validItems);
	}

	return validItems;
};

export const getCachedData = (key, matchFn) => readValidItems(key).find(matchFn) || null;

export const addToCachedData = (key, newItem, maxItems = 5) => {
	const items = getStorageItem(key) || [];

	if (items.length >= maxItems) {
		items.shift();
	}

	items.push(newItem);
	setStorageItem(key, items);
};

/**
 * Matches a cached image entry on the full query-parameter set, not just the VIN.
 */
export const getFromCache = (params) => {
	const { vin, apikey, queries } = params;
	const {
		night,
		roofOpen,
		background,
		uniformImage,
		fileFormat,
		cropped,
		cropPosition,
		backgroundItem,
	} = queries;
	const apikeyHash = hashString(apikey);

	return (
		readValidItems(STORAGE_KEYS.IMAGES).find(
			(element) =>
				element.vin === vin &&
				element.apikeyHash === apikeyHash &&
				element.night === night &&
				element.roofOpen === roofOpen &&
				element.background === background &&
				element.fileFormat === fileFormat &&
				element.cropped === cropped &&
				element.cropPosition === cropPosition &&
    			element.fallback === queries.fallback &&
				element.uniformImage === uniformImage &&
				element.backgroundItem === backgroundItem
		) || null
	);
};
